/* eslint-disable camelcase */
import { toast } from 'react-toastify';
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import ToastComponent from '../../components/toast';
import { WarrantExerciseService } from '@wealthlane/api-services/wealthlane-captable-service';
import type {
  Wealthlane_Shared_Hosting_Dtos_GenericApiResponse,
  Wealthlane_CapTable_Dtos_Warrant_FillWarrantFundedAmountDto,
} from '@wealthlane/api-services/wealthlane-captable-service';

const usePostFillWarrantFundedAmount = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  closeConfirmChangeModal: () => void,
  closeModal: () => void
): UseMutationResult<
  Wealthlane_Shared_Hosting_Dtos_GenericApiResponse | undefined,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: Wealthlane_CapTable_Dtos_Warrant_FillWarrantFundedAmountDto) => {
      return await handleRequest(
        WarrantExerciseService.postApiCapTableApiAppWarrantExerciseFillFundedAmount(payload)
      );
    },
    {
      onSuccess: async (
        response: Wealthlane_Shared_Hosting_Dtos_GenericApiResponse | undefined
      ) => {
        if (response?.isSuccess) {
          toast.success(<ToastComponent label='Success' message='Funded Amount Changed.' />);
          closeConfirmChangeModal();
          closeModal();
          await queryClient.invalidateQueries('getWarrantExerciseList');
        } else {
          closeConfirmChangeModal();
        }
      },
      onError: (err) => {
        console.log('error', err);
        closeConfirmChangeModal();
      },
    }
  );
};

export default usePostFillWarrantFundedAmount;
